import React from 'react';
import styled from 'styled-components';

type Props = {
    children: string,
}

const H5 = (props: Props) => {
    return (
        <H5WithStyled { ...props }>
            { props.children }
        </H5WithStyled>
    );
};

const H5WithStyled = styled.h5`
`

export default H5;